import { Globe2 } from "lucide-react";

const manifest = {
  key: "Importing_Entity_Plan",
  isFreeModule: false,
  isPurchasable: true,
  // Hidden from the menus and service lists for now; routes, access and plans are unchanged.
  hidden: true,
  icon: Globe2,
  names: {
    plan: {
      en: "Importing Entities",
      "zh-Hans": "进口实体",
      ar: "جهات الاستيراد",
    },
    dashboard: {
      en: "Importing Entities",
      "zh-Hans": "进口实体",
      ar: "جهات الاستيراد",
    },
  },
  defaultPath: "/importing-entities",
  matchers: [/^\/importing-entities(?:\/|$)/],
  buildNavbarMenus: ({ t, activeModuleLabel, isAuthorizedOnly, user }) => {
    const canManageImportRequests = !!user?.can_manage_import_requests;

    return [
      {
        label: activeModuleLabel,
        path: "__importing_entities__",
        children: [
          {
            label: t("menu_importing_entities_list") || "Importing Entities List",
            path: "/importing-entities",
          },
          ...(!isAuthorizedOnly || canManageImportRequests
            ? [
                {
                  label: t("menu_import_requests_tracking") || "Import Requests Tracking",
                  path: "/importing-entities/requests",
                },
              ]
            : []),
        ],
      },
    ];
  },
};

export default manifest;
